import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { supabase } from '@/lib/supabaseClient';
import BrandLogo from '@/components/brand/BrandLogo';
import { Button } from '@/components/ui/button';

const AdminNav = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [newCount, setNewCount] = useState(0);

  useEffect(() => {
    const load = async () => {
      try {
        const { count, error } = await supabase
          .from('leads')
          .select('*', { count: 'exact', head: true })
          .eq('status', 'New');
        if (error) throw error;
        setNewCount(count ?? 0);
      } catch {
        setNewCount(0);
      }
    };
    load();
    const interval = setInterval(load, 60000);
    return () => clearInterval(interval);
  }, []);

  const handleLogout = async () => {
    await supabase.auth.signOut();
    navigate('/admin/login', { replace: true });
  };

  const linkCls = (path) =>
    `px-4 py-2 rounded-md text-sm font-medium font-body transition-colors ${
      location.pathname === path
        ? 'bg-[#1B2D5E] text-white'
        : 'text-[#1B2D5E] hover:bg-[#F0F0F0]'
    }`;

  return (
    <header className="bg-white border-b border-atithi-border sticky top-0 z-50 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-3">
        <div className="flex items-center justify-between gap-3">
          <div className="flex items-center gap-3 min-w-0">
            <BrandLogo />
            <span className="text-xs font-body font-semibold tracking-wider text-atithi-orange uppercase hidden sm:inline">
              Admin
            </span>
          </div>
          <div className="flex items-center gap-2 shrink-0">
            <Button
              onClick={handleLogout}
              variant="outline"
              size="sm"
              className="border-[#1B2D5E] text-[#1B2D5E] hover:bg-[#1B2D5E] hover:text-white font-body"
            >
              Log out
            </Button>
            <Button
              onClick={() => { window.location.href = '/'; }}
              variant="outline"
              size="sm"
              className="border-atithi-navy text-atithi-navy hover:bg-atithi-navy hover:text-white font-body"
            >
              Back to Site
            </Button>
          </div>
        </div>
        <nav className="flex items-center gap-2 mt-3 flex-wrap">
          <Link to="/admin" className={linkCls('/admin')}>
            Dashboard
          </Link>
          <Link to="/admin/leads" className={`${linkCls('/admin/leads')} inline-flex items-center gap-2`}>
            <span aria-hidden>📋</span>
            Inquiries
            {newCount > 0 && (
              <span className="bg-[#E8651A] text-white text-[11px] font-semibold px-2 py-0.5 rounded-full min-w-[20px] text-center">
                {newCount}
              </span>
            )}
          </Link>
        </nav>
      </div>
    </header>
  );
};

export default AdminNav;
